import React from 'react';
import { connect } from 'react-redux';
import Text from '@bit/knotchinc.web-react-components.text';
import ArticleOptionsFilterItem from './ArticleOptionsFilterItem.jsx';
import { ContentFilterWrapper, ContentFilterItemContainer } from './styled.js';

const ArticleOptionsFilter = props => {
  const { filterAction, filters, setFilters, options, type, title } = props;
  const selectedType = filters[type];

  return (
    <ContentFilterWrapper>
      <Text textTransform="capitalize" fontSize={14}>
        {title}
      </Text>
      <ContentFilterItemContainer>
        {options.map((option) =>
          <ArticleOptionsFilterItem
            option={option}
            selectedType={selectedType}
            onClick={(selectedOption) => setFilters(filterAction, selectedOption === filters[type] ? '' : selectedOption)}
          />)}
      </ContentFilterItemContainer>
    </ContentFilterWrapper>
  );
};

const mapDispatchToProps = (dispatch, { type }) => ({
  setFilters: (actionType, data) => dispatch({ type: actionType, filters: { [type]: data, pageNum: 1 } }),
});

export default connect(null, mapDispatchToProps)(ArticleOptionsFilter);
